import React, { useState, useEffect } from 'react'
import {Button, Checkbox, Input, message, Popover} from 'antd'
import {WWUtils,WWMethods,wwConstants} from '@/tools'
import './login.scss';
import "antd/dist/antd.css";

const backgroundImg = require('@/assets/images/loginBg.png');
const loginLogo = localStorage.getItem("language") == "zh"?require('@/assets/images/loginlogo.svg'):require('@/assets/images/loginlogoen.svg')
export default function login(props, ref) {
    const [accountName, setAccountName] = useState('');
    const [password, setPassword] = useState('');
    const [code, setCode] = useState('');
    const [key, setKey] = useState('');
    const [homeBackgroundImg, setBackgroundImg] = useState(backgroundImg);
    const [codeImage, setCodeImage] = useState('');
    const [logoImgValue, setLogoImg] = useState(loginLogo);
    const [rememberMe, setRememberMe] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    useEffect(() => {
        //获取登录token,如果有，进入首页---start
        const user_token = WWMethods.getCookie("USER_TOKEN");
        //获取登录token,如果有，进入首页--- end
        document.getElementById("flagArea") && window.CountryFlag.createMutiLanFlag('flagArea',
            {
                visible: false,
                language: localStorage.getItem("language") || "zh",
                showFlagesModal: false,
                isShowLanguageDes: true,
                isShowFlags: false,
                LanguageHookerDesFontColor: "rgba(0,0,0,0.85)",
                popContainerWidth: 540,
                popContainerClass: "loginLanContainer",
                swithLan(e) {
                    localStorage.setItem('language', e)
                    getLangs(e,function () {
                        window.location.reload();
                    })

                },
                FlagChooseClick: function (str) {
                    if (str === "up") {
                        $("#lanToggle").addClass("up");
                    } else {
                        $("#lanToggle").removeClass("up");
                    }
                }
            });
    }, [])
    function submitLogin() {
        localStorage.removeItem("Strings_zh");
        localStorage.removeItem("localVersion_zh");
        localStorage.removeItem('isExpDome');
        localStorage.setItem('platform','mic')
        let url = WWMethods.getApiUrl("login");
        let model = {
            username: accountName,
            password: hex_md5(password) + hex_md5(randomString(10)),
            loginType: "USER",
            rememberMe: rememberMe,
        };
        const zoneId = WWUtils.getZoneName();
        WWMethods.setCookie('zoneId',zoneId);
        if (code) {
            model.loginCode = code;
            model.loginKey = key;
        }
        WWUtils.fetch(url, 'POST', model, function (res) {
            if (res.code === 0) {
                let data = res.data;
                WWMethods.addStorage(data.username, rememberMe, data.organizationId, 1);
                WWMethods.addCookie(data.username, password, rememberMe);
                localStorage.setItem("organizationName",data.organizationName)
                localStorage.setItem("rootId",data.rootId);
                //todo 权限列表后续接口调整了再完善
                
                localStorage.setItem("permissionList",JSON.stringify(data.permissionList || []));
                // alert("permissionManager"+data.permissionManager)
                localStorage.setItem("permissionManager",data.permissionManager || "0");
                //塞入首页页签；并默认选中
                if(localStorage.getItem("chosedTabs") && localStorage.getItem("setTabActiveKey")){
                   let chosedTabs = JSON.parse(localStorage.getItem("chosedTabs"));
                    let chosedItem = chosedTabs.filter((item)=> item.key === localStorage.getItem("setTabActiveKey"));
                    window.location.href= chosedItem[0].url?"/main.html#"+chosedItem[0].url: WWUtils.checkPermission("2-1") ? "/main.html#/home/monitoring/vinlist" : "/main.html#/home/panel";
                }else{
                    WWUtils.checkPermission("2-1")?WWUtils.addNavigationTab("2-1",Strings.vinlist || "车辆列表") : WWUtils.addNavigationTab("1-1",Strings.home || "首页");
                    window.location.href= WWUtils.checkPermission("2-1") ?"/main.html#/home/monitoring/vinlist" : "/main.html#/home/panel";
                }

            }else {
                message.error(res.message)
            }
        })
    }

    //生成指定长度的随机字符串
    function randomString(L) {
        var s = '';
        var randomchar = function () {
            var n = Math.floor(Math.random() * 62);
            if (n < 10) return n; //1-10
            if (n < 36) return String.fromCharCode(n + 55); //A-Z
            return String.fromCharCode(n + 61); //a-z
        };
        while (s.length < L) s += randomchar();
        return s;
    }
    //获取图形验证码
    function getImage() {
        $.ajax({
            type: "POST",
            dataType: 'json',
            url: "/rest/captcha/image",
            success: function (data) {
                setCodeImage(data.image)
                setKey(data.key);
            }, complete: function (xhr) {

            }
        });
    }
    //enter登录
    function loginKeyDown() {
        //同时支持chrome和firefox浏览器
        var theEvent = window.event || arguments.callee.caller.arguments[0];
        if (theEvent.keyCode === 13) {
            submitLogin();
        }
    }

    return <div className="login_container" style={{backgroundImage:`url(${homeBackgroundImg})`}}>
        <div className='language_wrap'>
            <div className='language_traget'>
                {/* 目标元素 */}
                <div id="flagArea" className="flagArea" style={{ marginLeft: '0' }}>
                    {/* //展开或者收起图标 */}
                    <i className="lanToggle" id="lanToggle"></i>
                </div>
            </div>
        </div>
        <div className="login_content">
            <div className="login_content_info">
                <div className="login_tab">
                    <img src={logoImgValue} />
                </div>
                <div className="login_content_account">
                    <div className="login_account_info">
                        <i className="login_icon iconfont icon-zhanghao" />
                        <Input name="username"
                            id="username"
                            type="text"
                            placeholder={Strings.account || "用户名"}
                            maxLength="64"
                            value={accountName}
                            onChange={(e) => {
                                setAccountName(e.target.value)
                            }}
                            onKeyDown={loginKeyDown} />
                    </div>
                    <div className="login_account_info">
                        <i className="login_icon iconfont icon-mima" id="Arlo-login-pwd" />
                        <Input type={showPassword?"text":"password"}
                            placeholder={Strings.password || "密码"}
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value)
                            }}
                            onKeyDown={loginKeyDown} />
                        {password?
                        <i onClick={()=>setShowPassword(!showPassword)}
                           className={showPassword ? 'login_icon iconfont icon-xianshi' : 'login_icon iconfont icon-yincang'}/>:null}
                    </div>
                    {
                        codeImage ? <div className='code_wrap'>
                            <div className=" check_code" id="code_div">
                                <i className="login_icon iconfont icon-yanzhengma" />
                                <Input type="text" onKeyDown={loginKeyDown} onChange={(e) => {
                                    setCode(e.target.value)
                                }} id="code" placeholder={Strings.imageCode || "图形验证码"} />
                            </div>
                            <img id="code_image" src={codeImage} onClick={getImage} />
                        </div> : null
                    }

                    <div className="login_other_row other_row_wrap">
                        <div>
                            <Checkbox onChange={() => { setRememberMe(!rememberMe) }} checked={rememberMe}>
                                <span className='remember_me'>{Strings.rememberMe || "记住密码"}</span>
                            </Checkbox>
                        </div>
                    </div>
                    <Button className="login_btn" type={"primary"} onClick={submitLogin} >
                        {Strings.loginBtn || "登录"}
                    </Button>

                </div>


            </div>

        </div>
        {WWUtils.isChina() ? <span className={"copyright_text"}>
            <a href={"https://beian.miit.gov.cn/#/Integrated/index"} target="_blank">沪ICP备14026039号-24</a>
        </span>:null}


    </div>
}